import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { MappingTipiEntitaFascicolo } from 'src/app/common/configuration/mapping-tipi-entita-fascicolo';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { NomiDescrittoriSezione } from '../../../../common/configuration/nomi-descrittori-sezione';
import { CssClassMapping } from '../../../../core/configuration/css-class-mapping';
import { FrontEndMapping } from '../../../../core/configuration/front-end-mapping';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from '../../../../core/services/modal-notify.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { RoutingConfigurationUtilService } from '../../../../core/services/routing-configuration-util.service';
import { DescrittoreSezione } from '../../../models/descrittore-sezione';
import { PraticaBase } from '../../../models/pratica/pratica-base';
import { FascicoloSelectModal } from '../../option-component/aggiungiFascicolo/fascicolo-select-modal.component';
import { CopiaPraticaComponent } from '../../option-component/copiaPratica/copia-pratica.component';
import { CorrelaPraticaComponent } from '../../option-component/correlaPratica/correla-pratica.component';
import { DeletePraticaComponent } from '../../option-component/deletePratica/delete-pratica.component';
import {
  RicercaPrecedentiComponent
} from '../../option-component/ricerca-precedenti/ricerca-precedenti/ricerca-precedenti.component';
import { ArchiviaModal } from './archivia-modal';
import {Subscription, tap} from 'rxjs';

declare var closeModal: any;
declare var openModal: any;
declare var getFascicoloMapSync: any;
declare var getPraticaMapSync: any;

@Component({
  selector: 'ul [intestazione_pratica]',
  templateUrl: 'intestazione-pratica.component.html',
  host: { '[class.pratiche]': '\'true\'' },
  styleUrls: ['intestazione-pratica.component.css']
})

export class IntestazionePraticaComponent implements OnInit, OnDestroy{
  @Input() pratica: PraticaBase;
  @Input() isFascicoloView : boolean = false;
  @Input() fascicolo: FascicoloFull;

  @ViewChild('fascicoloSelectModal') fascicoloSelectModal: FascicoloSelectModal;
  @ViewChild('correlaPraticaModal') correlaPraticaModal: CorrelaPraticaComponent;
  @ViewChild('deletePratica') deletePratica: DeletePraticaComponent;
  @ViewChild('copiaPraticaModal') copiaPraticaModal: CopiaPraticaComponent;
  @ViewChild('modaleDataArchiviazione') archiviaModal: ArchiviaModal;
  @ViewChild('ricercaPrecedentiModal') ricercaPrecedentiModal: RicercaPrecedentiComponent;


  tipoPratica: string;
  tipoPraticaClassCss: string;
  descrittori: DescrittoreSezione[];
  descrittoreDefinizione: boolean;
  descrittoreRimozioneDefinizione: boolean;
  descrittoreRiunisciGiudizi: boolean;
  descrittoreCancellazione: boolean;
  descrittoreCreazionePratica: boolean;
  descrittoreCopiaPratica: boolean;
  descrittoreArchiviazione: boolean;
  descrittoreRimozioneRiunione: boolean;
  isPraticaVisible: boolean = true;

  private subscription: Subscription;

  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();

  constructor(private operationService: OperationsService,
              private router: Router,
              private helpers: HelpersService,
              private routingService: RoutingConfigurationUtilService,
              private modalNotifyService: ModalNotifyService,
              private frontEndMapping: FrontEndMapping) { }

  onClickDelete(praticaBase: PraticaBase) {
    this.deletePratica.deletePratica(praticaBase);
  }

  ngOnInit() {
    this.frontEndMapping.getListTipiPratica(this.pratica.tipoPratica.id).subscribe(res => {
      this.tipoPratica = res; // FrontEndMapping.tipiPratica[this.pratica.tipoPratica.id];
    });

    this.tipoPraticaClassCss = this.getClassPratica(this.pratica.tipoPratica.id);
    this.helpers.getDescrittori().subscribe(res => this.setDescrittori(res));

    this.operationService.checkVisibilityPratica(this.pratica.id).pipe(
      tap(res => {
        this.isPraticaVisible = res;
      })
    ).subscribe();

    this.subscription = this.helpers.classificazione$.subscribe(classificazione => {
      if (classificazione.idPratica === this.pratica.id) {
        this.pratica.intestazione.campi.materia = classificazione.materia;
        this.pratica.intestazione.campi.oggetto = classificazione.oggetto;
      }
    });
  }

  callEmiter() {
    this.onReturn.emit();
  }

  returnCorrela(response: boolean) {
    if (this.pratica && response) {
      this.pratica.correlata = response;
    }
    this.onReturn.emit();
  }

  returnPrecedenti(value: boolean) {
    if(value) this.onReturn.emit();
  }

  setDescrittori(descrittori: DescrittoreSezione[]) {
    this.descrittori = descrittori;
    for (let descrittore of descrittori) {
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_DEFINIZIONE) {
        this.descrittoreDefinizione = descrittore.writable;
      }
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_DEFINIZIONE) {
        this.descrittoreRimozioneDefinizione = descrittore.writable;
      }
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIUNIONE_GIUDIZI) {
        this.descrittoreRiunisciGiudizi = descrittore.writable;
      }
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_CANCELLAZIONE) {
        this.descrittoreCancellazione = descrittore.writable;
      }
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_CREAZIONE_PRATICA) {
        this.descrittoreCreazionePratica = descrittore.writable;
      }
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_COPIA_PRATICA) {
        this.descrittoreCopiaPratica = descrittore.writable;
      }
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_ARCHIVIAZIONE) {
        this.descrittoreArchiviazione = descrittore.writable;
      }
      if (descrittore.entitySimpleName === NomiDescrittoriSezione.DESCRITTORE_RIMOZIONE_DEFINIZIONE) {
        this.descrittoreRimozioneRiunione = descrittore.writable;
      }
    }
  }

  hasFascicoloSanitario() : boolean {
    if(!!this.isFascicoloView){
      return !!(this.fascicolo && this.fascicolo.tipoFascicolo.id === MappingTipiEntitaFascicolo.FASCICOLO_SINISTRO_SANITARIO);
    } else {
      return !!(this.pratica['fascicoliLight'] && this.pratica['fascicoliLight'].find(element=>element.tipoFascicolo && element.tipoFascicolo.id===MappingTipiEntitaFascicolo.FASCICOLO_SINISTRO_SANITARIO));
    }
  }

  runMethodPraticaOption(method: string, pratica: PraticaBase) {
    switch (method) {
      case 'addFascicolo':
        this.addFascicolo(pratica);
        break;
      case 'copiaPratica':
        this.copiaPratica( pratica);
        break;
      case 'archiviaPratica':
        this.archiviaPratica(pratica);
        break;
      case 'correlaPratica':
        this.correlaPratica(pratica);
        break;
      case 'ricercaPrecedenti':
        this.ricercaPrecedenti(pratica);
        break;
    }
  }

  addFascicolo(pratica: PraticaBase) {
    this.fascicoloSelectModal.inizializza(this.pratica.tipoPratica, this.pratica.id);
    openModal('modaladdFascicolo');
  }

  getPraticaViewPath() {
    return ServicePathsSettings.VIEW_LABEL;
  }

  correlaPratica(pratica: PraticaBase) {
    this.correlaPraticaModal.inizializza(pratica);
    openModal('modalCorrelaPratica');
  }

  ricercaPrecedenti(pratica: PraticaBase){
    this.ricercaPrecedentiModal.inizializza(pratica);
    openModal('modalRicercaPrecedenti')
  }

  copiaPratica(pratica: PraticaBase) {
    this.copiaPraticaModal.inizializza(pratica);
    openModal('modalCopiaPratica');
  }

  getClassPratica(idTipoPratica) {
    return CssClassMapping.cssTipiPratica[idTipoPratica];
  }

  archiviaPratica(pratica: PraticaBase) {
    this.archiviaModal.inizializza(pratica);
  }


  manageModal() {
    closeModal('modaladdFascicolo');
    this.onReturn.emit();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}
